import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  return <section className="py-8 px-6 bg-[#0F0F0F]" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        {/* Header Section */}
        <div className="text-center mb-5" data-id="element-3">
          {/* Floating Tag - Elegant Gold */}
          <div className="inline-block bg-[#D4AF37] text-[#0F0F0F] text-xs font-bold px-4 py-1.5 rounded-full mb-3 shadow-sm" data-id="element-4">
            🎁 Bonos Exclusivos
          </div>

          {/* Heading with mixed colors */}
          <h2 className="text-xl md:text-2xl font-bold mb-3 leading-tight" data-id="element-5">
            <span className="text-white" data-id="element-6">Hoy te llevas 3 Bonos de Lujo </span>
            <span className="text-[#D4AF37]" data-id="element-7">(Valor $47)</span>
            <span className="text-white" data-id="element-8"> — GRATIS</span>
          </h2>

          {/* Paragraph 1 */}
          <p className="text-gray-400 text-[14px] md:text-[15px] leading-relaxed mb-2" data-id="element-9">
            No quiero que compres Mujer Digital 3.0 y después te quedes trabada
            en lo típico:{' '}
            <span className="italic text-gray-300" data-id="element-10">
              "no sé cómo hacerlo ver profesional", "no sé qué precio poner", "y
              si entrego mal..."
            </span>
          </p>

          {/* Paragraph 2 */}
          <p className="text-gray-300 font-medium text-[14px] md:text-[15px] mb-3" data-id="element-11">
            Por eso, si entras hoy, se desbloquean automáticamente estos 3
            bonos.
          </p>

          {/* Value Badge - Soft Pink */}
          <div className="inline-block bg-[#FF4DA6]/20 border border-[#FF4DA6]/30 rounded-lg px-4 py-2" data-id="element-12">
            <div className="text-xs text-gray-400 line-through mb-0.5" data-id="element-13">
              Valor total: $47
            </div>
            <div className="text-sm font-bold text-[#FF4DA6]" data-id="element-14">
              Hoy: $0 (gratis con tu compra)
            </div>
          </div>
        </div>

        {/* Compact Bonus Cards Stack */}
        <div className="space-y-3 mb-6" data-id="element-15">
          {/* BONO 1 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.35)] relative overflow-hidden" data-id="element-16">
            <div className="absolute top-0 left-0 w-1 h-full bg-[#D4AF37]" data-id="element-17"></div>
            <div className="mb-2 pl-2" data-id="element-18">
              <span className="inline-block bg-[#D4AF37]/20 text-[#D4AF37] text-[10px] font-bold px-2 py-0.5 rounded mb-1" data-id="element-19">
                BONO 1
              </span>
              <h3 className="text-base font-bold text-white mb-0.5" data-id="element-20">
                Pack 30 Ideas PDF
              </h3>
              <p className="text-[#FF4DA6] font-semibold text-xs" data-id="element-21">
                30 Ideas de PDF para vender por WhatsApp
              </p>
            </div>

            <p className="text-gray-400 text-xs mb-2 italic pl-2" data-id="element-22">
              Encuentra una idea que no solo te inspire, sino que se venda.
            </p>

            <p className="text-gray-300 text-xs mb-2 pl-2" data-id="element-23">
              No pierdas tiempo inventando. Usa ideas validadas para lanzar
              rápido.
            </p>

            <ul className="space-y-1 mb-2 pl-2" data-id="element-24">
              {['Ideas pensadas para mujeres ocupadas', 'Basadas en resultados reales', 'Títulos listos para copiar/pegar'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-25">
                  <Check className="w-3 h-3 text-[#4CAF50] flex-shrink-0" strokeWidth={3} data-id="element-26" />
                  <span className="text-xs text-gray-300" data-id="element-27">{item}</span>
                </li>)}
            </ul>

            <p className="text-gray-500 text-[10px] italic border-t border-white/10 pt-2 pl-2" data-id="element-28">
              Tu PDF empieza con claridad, no con dudas.
            </p>
          </div>

          {/* BONO 2 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.35)] relative overflow-hidden" data-id="element-29">
            <div className="absolute top-0 left-0 w-1 h-full bg-[#D4AF37]" data-id="element-30"></div>
            <div className="mb-2 pl-2" data-id="element-31">
              <span className="inline-block bg-[#D4AF37]/20 text-[#D4AF37] text-[10px] font-bold px-2 py-0.5 rounded mb-1" data-id="element-32">
                BONO 2
              </span>
              <h3 className="text-base font-bold text-white mb-0.5" data-id="element-33">
                Oferta Express (15 Min)
              </h3>
              <p className="text-[#FF4DA6] font-semibold text-xs" data-id="element-34">
                Tu precio + tu paquete sin dudar
              </p>
            </div>

            <p className="text-gray-300 text-xs mb-2 pl-2" data-id="element-35">
              Aprende a definir tu oferta de forma clara y rápida.
            </p>

            <ul className="space-y-1 mb-2 pl-2" data-id="element-36">
              {['Plantilla de "Mi oferta en 6 líneas"', 'Tabla de precios y comparativa', 'Fórmula para mostrar valor sin abrumar'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-37">
                  <Check className="w-3 h-3 text-[#4CAF50] flex-shrink-0" strokeWidth={3} data-id="element-38" />
                  <span className="text-xs text-gray-300" data-id="element-39">{item}</span>
                </li>)}
            </ul>

            <p className="text-gray-500 text-[10px] italic border-t border-white/10 pt-2 pl-2" data-id="element-40">
              No más dudas al vender, solo decisión.
            </p>
          </div>

          {/* BONO 3 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.35)] relative overflow-hidden" data-id="element-41">
            <div className="absolute top-0 left-0 w-1 h-full bg-[#D4AF37]" data-id="element-42"></div>
            <div className="mb-2 pl-2" data-id="element-43">
              <span className="inline-block bg-[#D4AF37]/20 text-[#D4AF37] text-[10px] font-bold px-2 py-0.5 rounded mb-1" data-id="element-44">
                BONO 3
              </span>
              <h3 className="text-base font-bold text-white mb-0.5" data-id="element-45">
                Entrega Pro (Celular)
              </h3>
              <p className="text-[#FF4DA6] font-semibold text-xs" data-id="element-46">
                Envío Premium + Testimonios
              </p>
            </div>

            <p className="text-gray-300 text-xs mb-2 pl-2" data-id="element-47">
              Aprende a entregar con confianza y sin parecer amateur.
            </p>

            <ul className="space-y-1 mb-2 pl-2" data-id="element-48">
              {['Checklist de entrega profesional', 'Mensajes listos (WhatsApp + Instagram)', 'Follow-up sin parecer insistente'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-49">
                  <Check className="w-3 h-3 text-[#4CAF50] flex-shrink-0" strokeWidth={3} data-id="element-50" />
                  <span className="text-xs text-gray-300" data-id="element-51">{item}</span>
                </li>)}
            </ul>

            <p className="text-gray-500 text-[10px] italic border-t border-white/10 pt-2 pl-2" data-id="element-52">
              Entrega simple, segura y con estilo.
            </p>
          </div>
        </div>

        {/* Summary - Text Only (No Card) */}
        <div className="text-center text-xs text-gray-500 space-y-1" data-id="element-53">
          <p data-id="element-54">
            Valor total de los 3 bonos:{' '}
            <span className="line-through" data-id="element-55">$47</span>
          </p>
          <p className="font-bold text-[#FF4DA6]" data-id="element-56">Hoy: GRATIS con tu compra</p>
          <p data-id="element-57">Se desbloquean automáticamente al entrar a Mujer Digital 3.0</p>
        </div>
      </div>
    </section>;
}